export enum LANGUAGE {
  GERMAN = 'german',
  ENGLISH = 'english'
}

export const languageOptions = [
  {
    label: 'Deutsch',
    value: LANGUAGE.GERMAN
  },
  {
    label: 'English',
    value: LANGUAGE.ENGLISH
  }
]
